import { SelectItem } from 'primereact/selectitem';
import { CustomObjectType } from '../objectTypesApi';
import _ from 'lodash';

export const mapObjectTypeToDropdownOption = (objectType: CustomObjectType): SelectItem => ({
  value: objectType.objectTypeId || objectType.objectTypeName,
  label: objectType?.singularLabel || _.startCase(objectType.objectTypeName),
});
